import { TakeawayServices } from './../../../takeaway/services';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { OrdersServices } from '../../../kitchen/services';
import { OrdersCoServices } from '../../../orders/services';
import { TranslateService } from '@ngx-translate/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { HttpClient } from '@angular/common/http';
import { CustomersServices } from '../../../customers/services';


/**
 * Generated class for the StockListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-popup-select-customer',
  templateUrl: 'popup-select-customer.html',
})
export class PopupSelectCustomer {
  title: any;
  table: any;
  tags_show: any = [];
  classActive: string;
  check_change_state: boolean;
  public firestore: any;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public globals: Globals,
    public ordersServices: OrdersServices,
    public ordersCoServices: OrdersCoServices,
    public http: HttpClient,
    public translate: TranslateService,
    public afs: AngularFirestore,
    public takeawayServices: TakeawayServices,
    public customersServices: CustomersServices,
    ) {
      this.title = this.navParams.get('title');

  }


  ionViewWillEnter() {
  
  }



  close() {      
    this.viewCtrl.dismiss();
  }

  async selectCustomer() {

    let data = await this.customersServices.getCustomer(this.takeawayServices.selectedPersonId);
    
    this.viewCtrl.dismiss(data);

  }
  

}



// WEBPACK FOOTER //
// ./src/pages/components/popups/popup-select-customer/popup-select-customer.ts